var _circle, _circle2, _ellipse, _path, _path2, _path3, _ellipse2, _circle3, _circle4, _path4, _path5, _path6, _circle5, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBestPlateBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "518 76 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 120,
    r: 34,
    fill: "#EEF3F8",
    stroke: "#FF9420",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 562,
    cy: 120,
    r: 25,
    fill: "#FFFFFF",
    stroke: "#FF9420",
    strokeWidth: 2.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 562,
    cy: 126,
    rx: 20,
    ry: 12,
    fill: "#FFE39A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M544,124 Q553,119 562,124 T580,123",
    fill: "none",
    stroke: "#FF922B",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M545,129 Q554,124 563,129 T580,128",
    fill: "none",
    stroke: "#FF922B",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M546,120 Q555,116 564,120 T579,119",
    fill: "none",
    stroke: "#FF922B",
    strokeWidth: 1.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 562,
    cy: 119,
    rx: 13,
    ry: 6.5,
    fill: "#FF5636"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 556,
    cy: 120,
    r: 3.6,
    fill: "#C0472B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 568,
    cy: 121,
    r: 3.6,
    fill: "#C0472B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M551,108 C547,101 555,96 551,90 S549,84 552,81",
    fill: "none",
    stroke: "#FFC21A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M562,110 C558,103 566,98 562,92 S560,86 563,83",
    fill: "none",
    stroke: "#FFC21A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M573,108 C569,101 577,96 573,90 S571,84 574,81",
    fill: "none",
    stroke: "#FFC21A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 588,
    cy: 98,
    r: 14,
    fill: "#2FC85C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M588,91 L595,99 L590.5,99 L590.5,106 L585.5,106 L585.5,99 L581,99 Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestPlateBanner);
export default __webpack_public_path__ + "static/media/best-plate-banner.84c213674b0f7aeb2478e1248afe7862.svg";
export { ForwardRef as ReactComponent };